// ===============================
// WHATS ON SECTION (UPDATED FOR RECCURING - MATCHES YOUR METAFIELD SPELLING)
// ===============================
// Requires these data attrs on .br-article-tile:
// - data-event-date="YYYY-MM-DD"           (only for dated events)
// - data-reccuring="true|false"            (reccuring events)
// - data-reccuring-order="number"          (optional, for ordering reccuring items)
function initWhatsonSection(root) {
  if (!root) return;

  var grid = root.querySelector(".whatsongrid");
  if (!grid) return;

  var toggles = root.querySelectorAll(".toggle-links .toggle");
  var toggleUpcoming = root.querySelector('[data-view="upcoming"]');
  var togglePast = root.querySelector('[data-view="past"]');

  var cards = Array.prototype.slice.call(root.querySelectorAll(".br-article-tile"));

  // Normalise "today" to midnight
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  var todayTs = today.getTime();

  var upcomingReccuring = [];
  var upcomingDated = [];
  var past = [];

  cards.forEach(function (card) {
    var isReccuring = (card.getAttribute("data-reccuring") === "true");
    var dateStr = card.getAttribute("data-event-date");

    // Reccuring items: always Upcoming (no date)
    if (isReccuring) {
      var orderStr = card.getAttribute("data-reccuring-order");
      var order = parseInt(orderStr, 10);
      if (isNaN(order)) order = 9999;
      card._reccuringOrder = order;
      upcomingReccuring.push(card);
      return;
    }

    // Non-reccuring but missing a date: treat as Past (and it will never show in Upcoming)
    // If you'd rather show these in Upcoming, tell me and I'll adjust.
    if (!dateStr) {
      past.push(card);
      return;
    }

  // dateStr is "YYYY-MM-DD"
    var d = new Date(dateStr + "T00:00:00");
    d.setHours(0, 0, 0, 0);

    var ts = d.getTime();
    card._eventTime = ts;

    // NEW: figure out the end date (falls back to start date if no range)
    var endDateStr = card.getAttribute("data-event-end-date");
    var endTs = ts;
    if (endDateStr) {
      var ed = new Date(endDateStr + "T00:00:00");
      ed.setHours(0, 0, 0, 0);
      endTs = ed.getTime();
    }
    card._eventEndTime = endTs;

    // CHANGED: compare end date, not start date
    if (endTs >= todayTs) {
      upcomingDated.push(card);
    } else {
      past.push(card);
    }
  });

  // Sort arrays:
  // reccuring: reccuring_order ASC (lowest first)
  upcomingReccuring.sort(function (a, b) {
    return (a._reccuringOrder || 9999) - (b._reccuringOrder || 9999);
  });

  // upcoming dated: nearest first
  upcomingDated.sort(function (a, b) {
    return a._eventTime - b._eventTime;
  });

  // past: most recent first (only those with _eventTime will sort reliably)
  past.sort(function (a, b) {
    var at = typeof a._eventTime === "number" ? a._eventTime : -Infinity;
    var bt = typeof b._eventTime === "number" ? b._eventTime : -Infinity;
    return bt - at;
  });

  // Final upcoming list: reccuring FIRST, then dated
  var upcoming = upcomingReccuring.concat(upcomingDated);

  // Hide Past toggle if no past events
  if (past.length === 0 && togglePast) {
    togglePast.style.display = "none";
  } else if (togglePast) {
    togglePast.style.display = "";
  }

  // Read limit from data attribute or default to 6
  var pastLimitAttr = root.getAttribute("data-past-limit");
  var pastLimit = parseInt(pastLimitAttr, 10);
  if (isNaN(pastLimit)) pastLimit = 6;

  function setToggleState(view) {
    toggles.forEach(function (t) {
      if (t.getAttribute("data-view") === view) {
        t.classList.add("is-active");
      } else {
        t.classList.remove("is-active");
      }
    });
  }

  function render(view, animate) {
    var list = view === "past" ? past : upcoming;
    var limit = view === "past" ? pastLimit : Infinity;
    var cardsToShow = [];

    // Prevent switching to Past view if there are NO past items
    if (view === "past" && past.length === 0) return;

    var canAnimate = !!(animate && window.gsap);

    setToggleState(view);

    function swapContent() {
      // Clear grid
      while (grid.firstChild) {
        grid.removeChild(grid.firstChild);
      }

      var count = 0;
      list.forEach(function (card) {
        if (count >= limit) return;

        card.style.display = "";
        card.style.opacity = canAnimate ? 0 : 1;

        grid.appendChild(card);
        cardsToShow.push(card);
        count++;
      });

      // Fade IN
      if (canAnimate && cardsToShow.length) {
        gsap.to(cardsToShow, {
          opacity: 1,
          duration: 0.4,
          stagger: 0.05,
          ease: "power2.out",
        });
      }
    }

    if (canAnimate) {
      var currentCards = Array.prototype.slice.call(grid.children);

      if (currentCards.length) {
        gsap.to(currentCards, {
          opacity: 0,
          duration: 0.3,
          ease: "power2.in",
          onComplete: function () {
            currentCards.forEach(function (c) {
              c.style.display = "none";
            });
            swapContent();
          },
        });
      } else {
        swapContent();
      }
    } else {
      swapContent();
    }
  }

  // Bind toggle clicks
  toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      var view = toggle.getAttribute("data-view") || "upcoming";
      render(view, true);
    });
  });

  // Initial render
  render("upcoming", false);
}

// Init WHATS ON (separate DOM init)
document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll(
    '.barrelroom-whatson[data-section-type="article-list"]'
  );
  sections.forEach(function (root) {
    initWhatsonSection(root);
  });
});





// ===============================
// MARQUEE
// ===============================
function initCSSMarquee() {
  const pixelsPerSecond = 75; // Set the marquee speed (pixels per second)
  const marquees = document.querySelectorAll('[data-css-marquee]');
  
  // Duplicate each [data-css-marquee-list] element inside its container
  marquees.forEach(marquee => {
    marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
      const duplicate = list.cloneNode(true);
      marquee.appendChild(duplicate);
    });
  });

  // Create an IntersectionObserver to check if the marquee container is in view
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.querySelectorAll('[data-css-marquee-list]').forEach(list => 
        list.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused'
      );
    });
  }, { threshold: 0 });
  
  // Calculate the width and set the animation duration accordingly
  marquees.forEach(marquee => {
    marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
      list.style.animationDuration = (list.offsetWidth / pixelsPerSecond) + 's';
      list.style.animationPlayState = 'paused';
    });
    observer.observe(marquee);
  });
}

// Init MARQUEE (separate DOM init)
document.addEventListener('DOMContentLoaded', function() {
  initCSSMarquee();
});



// ===============================
// STAGGER BUTTONS
// ===============================
function initButtonCharacterStagger() {
  const offsetIncrement = 0.01; // Transition offset increment in seconds
  const buttons = document.querySelectorAll('[data-button-animate-chars]');

  buttons.forEach(button => {
    const text = button.textContent; // Get the button's text content
    button.innerHTML = ''; // Clear the original content

    [...text].forEach((char, index) => {
      const span = document.createElement('span');
      span.textContent = char;
      span.style.transitionDelay = `${index * offsetIncrement}s`;

      // Handle spaces explicitly
      if (char === ' ') {
        span.style.whiteSpace = 'pre'; // Preserve space width
      }

      button.appendChild(span);
    });
  });
}

// Init STAGGER BUTTONS (separate DOM init)
document.addEventListener('DOMContentLoaded', function() {
  initButtonCharacterStagger();
});



// ===============================
// BARRELROOM ENQUIRY FORM TOGGLE
// ===============================
function initBarrelroomEnquiryForm() {
  const formBg = document.querySelector('.form-bg');

  const mainForm  = document.querySelector('.br-form-wrapper.br-mainform');
  const musicForm = document.querySelector('.br-form-wrapper.music-form');

  if (!formBg || (!mainForm && !musicForm)) return;

  const enquiryButtons   = document.querySelectorAll('.br-enquiry-btn');
  const liveMusicButtons = document.querySelectorAll('.br-livemusic-btn');
  const closeTriggers    = document.querySelectorAll('.br-form-close, .form-bg');

  function closeAllForms() {
    if (mainForm) mainForm.classList.remove('is-active');
    if (musicForm) musicForm.classList.remove('is-active');
    formBg.classList.remove('is-active');
  }

  function openForm(targetForm) {
    if (!targetForm) return;
    closeAllForms(); // ensure only one open at a time
    targetForm.classList.add('is-active');
    formBg.classList.add('is-active');
  }

  // Open main enquiry form
  enquiryButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openForm(mainForm);
    });
  });

  // Open live music form
  liveMusicButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openForm(musicForm);
    });
  });

  // Close all forms
  closeTriggers.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      closeAllForms();
    });
  });
}

// Init ENQUIRY FORM (separate DOM init)
document.addEventListener('DOMContentLoaded', function () {
  initBarrelroomEnquiryForm();
});






// ===============================
// CLICK/HOVER EVENTS
// ===============================

$(".accordion-header").on("click", function () {
  $(this).closest(".accordion").toggleClass("open");
});